export default __webpack_public_path__ + "static/media/menu_photo1.387dfc13.png";